<template>
  <v-dialog
    :value="isConfigurarCelulaDialogOpen"
    max-width="800px"
    persistent
  >
    <v-card class="pa-sm-8 pa-2">
      <btn-close-dialog :handle-click="closeDialog" />

      <v-card-title class="justify-center text-h5 pt-0">
        Configurar componente
      </v-card-title>

      <v-card-text class="mt-5">
        <v-form
          ref="formRef"
          class="multi-col-validation"
          @submit.prevent="handleSubmit"
        >
          <v-row>
            <v-col cols="12">
              <select-tipo-de-componente
                :componente-tipo-id.sync="state.idElementoTipo"
                :is-componente-novo="componenteProps.novo"
                :filtrar-componentes-quen-nao-podem-ser-enviados-por-chat-bot.sync="filtrarComponentesQueNaoPodemSerEnviadosPorChatBot"
                :tipos-de-componentes.sync="tiposDeComponentes"
              />
            </v-col>
          </v-row>

          <v-row v-if="isComponenteTipo.DropdownListEncadeado">
            <v-col cols="12">
              <v-select
                v-model="qtdComponentesEncadeados"
                dense
                outlined
                validate-on-blur
                label="Quantidade:"
                :items="quantidadesPermitidasDeComponentesEncadeados"
                :rules="[validators.select]"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-if="!isComponenteTipo.DropdownListEncadeado"
              md="6"
              cols="12"
            >
              <v-text-field
                v-model="state.nome"
                dense
                outlined
                label="Nome do componente:"
                counter="20"
                validate-on-blur
                hint="Máximo de 20 caracteres"
                persistent-hint
                :append-icon="icons.mdiFormatText"
                :rules="[validators.required, validators.strSemEspacoEmBrancoECaracteresEspeciais, (v) => (!!v && v.length <= 20) || 'Máximo de 20 caracteres']"
              />
            </v-col>

            <v-col
              v-if="!isComponenteTipo.DropdownListEncadeado"
              md="6"
              cols="12"
            >
              <v-text-field
                v-model="state.label"
                dense
                outlined
                label="Label"
                counter="50"
                validate-on-blur
                hint="Máximo de 50 caracteres"
                persistent-hint
                :append-icon="icons.mdiLabel"
                :rules="[validators.required, (v) => (!!v && v.length <= 50) || 'Máximo de 50 caracteres']"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-if="isComponenteTipo.Label"
              cols="12"
            >
              <v-tooltip
                top
                color="primary"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-textarea
                    v-model="state.texto"
                    v-bind="attrs"
                    dense
                    outlined
                    no-resize

                    :label="labelInputProps.label"
                    counter="1000"
                    validate-on-blur
                    hint="Máximo de 1000 caracteres"
                    persistent-hint
                    :rules="[validators.required, (v) => (!!v && v.length <= 1000) || 'Máximo de 1000 caracteres']"
                    v-on="on"
                  />
                </template>
                <span>{{ labelInputProps.tooltip }}</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-if="maxLengthInputProps.show"
              cols="12"
            >
              <v-tooltip
                top
                color="primary"
              >
                <template #activator="{ on, attrs } ">
                  <v-text-field
                    v-model="state.maxLength"
                    v-bind="attrs"
                    dense
                    outlined
                    validate-on-blur
                    type="number"
                    min="1"
                    label="Tamanho máximo:"
                    hint="Mínimo 1 e máximo 5000"
                    :filled="maxLengthInputProps.readonly"
                    :readonly="maxLengthInputProps.readonly"
                    :rules="[(v) => !!v || 'Este campo é obrigatório', (v) => (!!v && v >= 1 && v <= 5000) || 'Mínimo 1 e máximo 5000']"
                    v-on="on"
                  />
                </template>
                <span>{{ maxLengthInputProps.tooltip }}</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-if="isComponenteTipo.BotaoEmail"
              cols="12"
              class="d-flex pb-0"
            >
              <v-text-field
                v-model="state.nomeComponenteEmail"
                dense
                outlined
                label="Nome do componente com e-mail:"
                counter="50"
                validate-on-blur
                hint="Máximo de 50 caracteres"
                persistent-hint
                :rules="[validators.required, (v) => (!!v && v.length <= 50) || 'Máximo de 50 caracteres']"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-if="isComponenteTipo.BotaoEmail"
              cols="12"
            >
              <botao-email :template.sync="state.template" />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              class="d-flex"
            >
              <v-switch
                v-if="componenteProps.obrigatorio"
                v-model="state.obrigatorio"
                hide-details
                class="my-0 mr-4"
                label="Obrigatório"
              />

              <v-switch
                v-if="!isComponenteTipo.BotaoEmail"
                v-model="state.visivel"
                hide-details
                class="my-0"
                label="Visível"
              />

              <v-switch
                v-if="componenteProps.novo && isComponenteTipo.TextBox"
                v-model="state.multiline"
                hide-details
                class="my-0 ml-4"
                label="Multiline"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-if="isComponenteTipo.DropdownListEncadeado && qtdComponentesEncadeados"
              cols="12"
            >
              <v-divider class="mb-7" />

              <componente-encadeado
                :index="0"
                :nome.sync="state.nome"
                :label.sync="state.label"
                :orbigatorio.sync="state.obrigatorio"
              />

              <componente-encadeado
                v-for="(componente, index) in componentesEncadeados"
                :key="index + 1"
                :index="index + 1"
                :is-last="index + 1 === componentesEncadeados.length"
                :id-elemento-tipo.sync="componente.idElementoTipo"
                :nome.sync="componente.nome"
                :label.sync="componente.label"
                :obrigatorio.sync="componente.obrigatorio"
                :tipos-de-componentes-encadeaveis.sync="tiposDeComponentes.encadeaveis"
              />

              <excel-dados-encadeados :opcoes-excel.sync="opcoesExcel" />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              v-if="!isComponenteTipo.DropdownListEncadeado && componenteProps.aceitaItens"
              cols="12"
            >
              <tabela-de-opcoes :opcoes.sync="state.opcoes" />
            </v-col>
          </v-row>

          <v-row v-if="isComponenteTipo.Numerico">
            <v-col cols="12">
              <componente-numerico-form
                :componente-numerico-subtipo-id.sync="state.componenteNumericoSubtipoId"
                :is-componente-novo="componenteProps.novo"
              />
            </v-col>
          </v-row>

          <v-divider class="mt-5 mb-3" />

          <v-row
            cols="12"
            class="justify-center mt-4"
          >
            <v-btn
              outlined
              class="mr-3"
              color="secondary"
              :disabled="loading"
              @click="componenteProps.novo ? resetFormAndCloseDialog() : closeDialog()"
            >
              Cancelar
            </v-btn>

            <v-btn
              color="primary"
              :disabled="submitBtnProps.disabled"
              type="submit"
            >
              <v-progress-circular
                v-if="loading"
                class="mx-3"
                indeterminate
                color="secundary"
              />

              <span v-else>{{ submitBtnProps.title }}</span>
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { mdiFormatText, mdiLabel } from '@mdi/js'
import { ref, computed, watch } from '@vue/composition-api'
import { select, required } from '@core/utils/validation'
import { storeToRefs } from 'pinia'
import router from '@/router'
import BtnCloseDialog from '@/components/btn-close-dialog/BtnCloseDialog.vue'
import SelectTipoDeComponente from './SelectTipoDeComponente.vue'
import TabelaDeOpcoes from './TabelaDeOpcoes.vue'
import BotaoEmail from './BotaoEmail.vue'
import ComponenteEncadeado from './drop-down-list-encadeado/ComponenteEncadeado.vue'
import ExcelDadosEncadeados from './drop-down-list-encadeado/ExcelDadosEncadeados.vue'
import ComponenteNumericoForm from './ComponenteNumericoForm.vue'
import ComponenteClass from '@/models/entities/formulario/componente/Componente'
import TiposDeComponentesEnum from '@/models/entities/formulario/componente/TiposDeComponentesEnum'
import FormularioService from '@/services/modules/FormularioService'
import { strSemEspacoEmBrancoECaracteresEspeciais } from '@/utils/validation'
import useDialog from '@/composables/useDialog'
import useFormularioViewStore from '@/store/formulario-view'
import ComponenteNumericoSubtiposEnum from '@/models/entities/formulario/componente/ComponenteNumericoSubtiposEnum'

export default {
  components: {
    BtnCloseDialog,
    SelectTipoDeComponente,
    TabelaDeOpcoes,
    BotaoEmail,
    ComponenteEncadeado,
    ExcelDadosEncadeados,
    ComponenteNumericoForm,
  },

  props: {
    isConfigurarCelulaDialogOpen: {
      type: Boolean,
      required: true,
    },
    componenteData: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const tiposDeComponentes = ref({ todos: [], encadeaveis: [] })
    const state = ref(new ComponenteClass())
    watch(() => props.componenteData, () => { state.value = new ComponenteClass(props.componenteData) }, { immediate: true, deep: true })

    const componentesQueNaoPodemSerObrigatorios = [TiposDeComponentesEnum.CheckBox, TiposDeComponentesEnum.DropDownListEncadeado, TiposDeComponentesEnum.BotaoEmail, TiposDeComponentesEnum.Label]
    const componentesQueAceitamItens = [TiposDeComponentesEnum.RadioGroup, TiposDeComponentesEnum.DropDownList]

    const componenteProps = computed(() => ({
      obrigatorio: !componentesQueNaoPodemSerObrigatorios.includes(state.value.idElementoTipo),
      aceitaItens: componentesQueAceitamItens.includes(state.value.idElementoTipo),
      novo: state.value.id === 0,
    }))

    const isComponenteTipo = computed(() => ({
      TextBox: state.value.idElementoTipo === TiposDeComponentesEnum.TextBox,
      BotaoEmail: state.value.idElementoTipo === TiposDeComponentesEnum.BotaoEmail,
      DropdownListEncadeado: state.value.idElementoTipo === TiposDeComponentesEnum.DropDownListEncadeado,
      Label: state.value.idElementoTipo === TiposDeComponentesEnum.Label,
      Numerico: state.value.idElementoTipo === TiposDeComponentesEnum.Numerico,
    }))

    const isComponenteSubtipo = computed(() => ({
      Moeda: state.value.componenteNumericoSubtipoId === ComponenteNumericoSubtiposEnum.MoedaId,
    }))

    const { formRef, loading, resetForm, closeDialog, emitRefetchData } = useDialog(emit, 'is-configurar-celula-dialog-open')
    const opcoesExcel = ref([])

    const quantidadesPermitidasDeComponentesEncadeados = [2, 3, 4, 5]
    const componentesEncadeados = ref(ComponenteClass.listarComponentesEncadeados(state.value.elementoEncadeado))
    const qtdComponentesEncadeados = ref(componentesEncadeados.value !== null ? componentesEncadeados.value.length + 1 : 0)
    function handleQtdComponentesEncadeadosChange(newQtd) {
      if (newQtd === 0) return
      const length = newQtd - 1
      componentesEncadeados.value = ComponenteClass.getArrayDeComponentesEncadeadosComDadosDefault(length, state.value.linha, state.value.coluna)
    }
    watch(qtdComponentesEncadeados, handleQtdComponentesEncadeadosChange)

    function handleComponenteSubtipoChange() {
      if (isComponenteTipo.value.Numerico && isComponenteSubtipo.value.Moeda) {
        state.value.maxLength = 11
      }
    }
    watch(() => state.value.componenteNumericoSubtipoId, handleComponenteSubtipoChange)

    function resetData() {
      resetForm()
      state.value = JSON.parse(JSON.stringify(props.componenteData))
      opcoesExcel.value = []
      componentesEncadeados.value = null
    }
    function resetFormAndCloseDialog() {
      resetData()
      closeDialog()
    }
    function processamentoDepoisDeRequestBemSucedida() {
      emitRefetchData()
      setTimeout(() => { loading.value = false }, 1000)
      closeDialog()
    }

    function getRequestBody() {
      return {
        elemento: {
          ...state.value,
          opcoes: !componenteProps.value.aceitaItens ? null : state.value.opcoes,
          multiline: !isComponenteTipo.value.TextBox ? null : state.value.multiline,
          visivel: isComponenteTipo.value.BotaoEmail ? true : state.value.visivel,
          template: !isComponenteTipo.value.BotaoEmail ? null : state.value.template,
          obrigatorio: isComponenteTipo.value.BotaoEmail ? false : state.value.obrigatorio,
          elementoEncadeado: !isComponenteTipo.value.DropdownListEncadeado ? null : ComponenteClass.aninharComponentesEncadeados(componentesEncadeados.value),
        },
        opcoesMatriz: isComponenteTipo.value.DropdownListEncadeado && opcoesExcel.value.length ? opcoesExcel.value : null,
      }
    }
    async function createComponente() {
      try {
        loading.value = true
        await FormularioService.createComponente(router.currentRoute.params.id, state.value.idFormularioSecao, getRequestBody())
        processamentoDepoisDeRequestBemSucedida()
      } catch {
        loading.value = false
      }
    }
    async function updateComponente() {
      try {
        loading.value = true
        await FormularioService.updateComponente(router.currentRoute.params.id, state.value.idFormularioSecao, state.value.id, getRequestBody())
        processamentoDepoisDeRequestBemSucedida()
      } catch {
        loading.value = false
      }
    }
    async function handleSubmit() {
      if (loading.value) return
      if (formRef.value.validate() && componenteProps.value.novo) {
        await createComponente()
      } else if (formRef.value.validate() && !componenteProps.value.novo) {
        await updateComponente()
      } else {
        Vue.$toast.warning('Preencha corretamente os campos antes de salvar')
      }
    }

    const maxLengthInputProps = computed(() => ({
      show: (isComponenteTipo.value.TextBox || (isComponenteTipo.value.Numerico && isComponenteSubtipo.value.Moeda)),
      readonly: (isComponenteTipo.value.Numerico && isComponenteSubtipo.value.Moeda),
      tooltip: (isComponenteTipo.value.Numerico && isComponenteSubtipo.value.Moeda ? 'O subtipo \'Moeda\' permite no máximo 11 caracteres ou até o valor R$ 999.999.999,99 (desconsiderando os caracteres especiais).' : ''),
    }))
    const labelInputProps = computed(() => ({
      label: (isComponenteTipo.value.Label ? 'Texto:' : 'Label:'),
      tooltip: (isComponenteTipo.value.Label ? 'Texto que aparecerá para o usuário' : 'Nome que aparecerá para o usuário'),
    }))
    const submitBtnProps = computed(() => ({
      title: (componenteProps.value.novo ? 'Adicionar' : 'Salvar alterações'),
      disabled: (componenteProps.value.aceitaItens && state.value.opcoes.length === 0) || loading.value,
    }))

    const filtrarComponentesQueNaoPodemSerEnviadosPorChatBot = ref(false)
    const { isFormularioBot } = storeToRefs(useFormularioViewStore())
    watch(() => props.isConfigurarCelulaDialogOpen, () => { filtrarComponentesQueNaoPodemSerEnviadosPorChatBot.value = isFormularioBot.value }, { immediate: true, deep: true })

    return {
      tiposDeComponentes,
      state,
      componenteProps,
      isComponenteTipo,
      formRef,
      loading,
      opcoesExcel,
      quantidadesPermitidasDeComponentesEncadeados,
      componentesEncadeados,
      qtdComponentesEncadeados,
      closeDialog,
      resetFormAndCloseDialog,
      handleSubmit,
      maxLengthInputProps,
      labelInputProps,
      submitBtnProps,
      filtrarComponentesQueNaoPodemSerEnviadosPorChatBot,
      icons: {
        mdiFormatText,
        mdiLabel,
      },
      validators: {
        select,
        required,
        strSemEspacoEmBrancoECaracteresEspeciais,
      },
    }
  },
}
</script>
